import { GridContainer } from 'libs/ui';
import { Plate } from 'grids/plate/plate';

export const PlateWrapper = (props) => {
  return (
    <GridContainer>
      <Plate {...props} />
    </GridContainer>
  );
};
